// @flow
import { setAuthorizationToken } from 'utils/setAuthorizationToken';
import dispatchAsync from 'utils/dispatchAsync';
import jwt from 'jsonwebtoken';
import CryptoJS from 'crypto-js';
import firebase from 'firebase/app';

import type { ZuzuThunk } from 'types';

export type User = {
  username: string,
  communityId: string,
};

type UserCredentials = {
  username: string,
  password: string,
};

export type LoginAction = {
  type: 'LOGIN',
  payload?: User,
  meta: {
    done: boolean,
    error?: boolean,
  },
};
export const FIREBASE_LOGIN = 'FIREBASE_LOGIN';
export const LOGIN = 'LOGIN';
export const login = (uc: UserCredentials): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: LOGIN,
    url: '/api/management/session/login',
    method: 'post',
    body: {
      username: uc.username,
      passwordHash: CryptoJS.SHA1(uc.password).toString(),
    },
    dispatch,
    transform: token => jwt.decode(token),
    crunchHeaders: async headers => {
      if (headers.fbtoken) {
        const authResponse = await firebase
          .auth()
          .signInWithCustomToken(headers.fbtoken);
        console.log('signed in with fb', authResponse);
      }
    },
  }).then(async payload => {
    setAuthorizationToken(payload);
    localStorage.setItem('userToken', payload);
  });
};

export type TokenLoginAction = {
  type: 'TOKEN_LOGIN',
  payload: User,
};
export const TOKEN_LOGIN = 'TOKEN_LOGIN';
export const tokenLogin = (token: string): TokenLoginAction => ({
  type: TOKEN_LOGIN,
  payload: jwt.decode(token),
});

export type LogoutAction = {
  type: 'LOGOUT',
  payload: null,
};
export const LOGOUT = 'LOGOUT';
export const logout = (): LogoutAction => {
  localStorage.removeItem('userToken');
  firebase.auth().signOut();
  return { type: LOGOUT, payload: null };
};



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js